var isPointerDragNormal = true;
